import { Injectable, inject } from '@angular/core';
import { ApigeeTokenGenerator } from './apigee-token-generator';
import { Observable, switchMap, map, shareReplay } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { JsonXlsxService } from './json-xlsx-service';

@Injectable({
  providedIn: 'root',
})
export class FileContentService {
  private httpClient = inject(HttpClient);
  private apigeeTokenGeneratorService = inject(ApigeeTokenGenerator);
  private jsonToXlsxService = inject(JsonXlsxService);

  private getFileContent(fileId: string): Observable<any> {
    const fileContentEndpoint = `${environment.apigeeConfig.domain}${environment.apigeeConfig.fileContentEndpoint.replace('{fileId}',fileId)}`;
    return this.apigeeTokenGeneratorService.generateApigeeToken()
    .pipe(
      switchMap(token => {
        return this.httpClient.get<any>(fileContentEndpoint,
          {
            headers: {'Authorization': `Bearer ${token.access_token}`}
          }
        );
      })
    )
  }


  getXLSXDownloadLink(id: string): Observable<string> {
    const downloadLink$ = this.getFileContent(id).pipe(
      map(jsonData => {
        const buffer = this.jsonToXlsxService.exportToExcel(jsonData);
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = URL.createObjectURL(blob);
        const documentType = jsonData?.salesorder?.lines ? 'order_details' : 'product_details';
        const orderNumber = jsonData?.salesorder?.orderNumber;
        const fileName = orderNumber? `${documentType}_${orderNumber}_${new Date().toJSON().split('T')[0]}` :`${documentType}_${id}`;
        return `<a href="${url}" download="${fileName}.xlsx">Download ${fileName}.xlsx</a>`;
      }),
      shareReplay(1)
    );

    return downloadLink$;
  }
}
